import { AutoMap } from "@automapper/classes";

export class MaterielEauDTO {
    @AutoMap()
    type!: number;
    @AutoMap()
    materiau!: string;
    @AutoMap()
    reference!: string;
    @AutoMap()
    nombreDouche!: number;
    @AutoMap()
    dateChangementFiltre!: string;
    @AutoMap()
    localisationRejet!: number;
}